import React from 'react';
import { observer, inject } from 'mobx-react';
import * as Util from '../../util/formUtil';
import * as FieldUtil from '../../util/public/fieldUtil';
import * as _ from '../../util/public/common';

@inject('globalStore', 'layoutStore')
@observer
export default class HiddenArea extends React.Component {
    render(){
        const { globalStore,layoutStore } = this.props;
        const { JSComplete,submitParam } = globalStore;
        const { fieldAttrMap,mainData,detailMap,cellInfo, propFileCfg } = layoutStore;
        const fieldCellInfo = cellInfo.fieldCellInfo || {};
        
        let arr = [];
        _.forIn(submitParam, (v,k) =>{
            arr.push(<input type="hidden" id={k} name={k} value={v}/>);
        });
        //字段不在模板上需生成隐藏域
        fieldAttrMap.forEach((attr,fieldid) =>{
            if(fieldid in fieldCellInfo)
                return true;
            if(attr.isDetail){  //明细字段˛
                const detailObj = detailMap.get(attr.tableMark);
                const { allRowIndexStr, detailData, currentPageRowIndexStr, rowInfoArr } = detailObj;
                const { detail_hideArea_control } = propFileCfg;
                //优化明细表数据量大时渲染卡顿问题
                const detail_optimize_enablenum = (detail_hideArea_control > 0) ? detail_hideArea_control : 100;
                const rowIndexStr = (rowInfoArr.length > detail_optimize_enablenum) ? currentPageRowIndexStr : allRowIndexStr;
                rowIndexStr.split(",").map(rowIndex =>{
                    const fieldKey = `field${fieldid}_${rowIndex}`;
                    const fieldValue = detailData.has(fieldKey) ? detailData.get(fieldKey).value : "";
                    arr.push(<input type="hidden" id={fieldKey} name={fieldKey} value={fieldValue} />);
                });
            }else{
                let fieldKey = `field${fieldid}`;
                const fieldValue = mainData.has(fieldKey) ? mainData.get(fieldKey).value : "";
                if(parseInt(fieldid) < 0)
                    fieldKey = FieldUtil.convertSystemFieldName(fieldKey);
                arr.push(<input type="hidden" id={fieldKey} name={fieldKey} value={fieldValue} />);
            }
        });
        //明细相关隐藏域
        detailMap.forEach((detailObj,detailMark) =>{
            const detailIndex = parseInt(detailMark.substring(7)) - 1;
            const { indexnum,deldtlid,rowInfo } = detailObj;
            let submitdtlid = "";
            let nodesnum = 0;
            rowInfo.forEach((info,rowKey) =>{
                nodesnum++;
                const rowIndex = rowKey.substring(4);
                submitdtlid += rowIndex+",";
                if(info.has("keyid"))
                    arr.push(<input type="hidden" name={`dtl_id_${detailIndex}_${rowIndex}`} value={info.get("keyid")} />);
            });
            arr.push(<input type="hidden" id={`nodesnum${detailIndex}`} name={`nodesnum${detailIndex}`} value={nodesnum} />);
            arr.push(<input type="hidden" id={`indexnum${detailIndex}`} name={`indexnum${detailIndex}`} value={indexnum} />);
            arr.push(<input type="hidden" id={`submitdtlid${detailIndex}`} name={`submitdtlid${detailIndex}`} value={submitdtlid} />);
            arr.push(<input type="hidden" id={`deldtlid${detailIndex}`} name={`deldtlid${detailIndex}`} value={deldtlid} />);
        });
        return (
            <div class="hiddenArea" style={{display:"none"}}>
                { arr }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/layout/HiddenArea.js